import {
    GET_TRANSLATIONS_REQUEST,
    GET_TRANSLATIONS_RESPONSE,
} from '../actions/actionsTypes';

export const translationsReducer = (state = {}, action) => {
    switch (action.type) {
        case GET_TRANSLATIONS_REQUEST:
            return {
                ...state,
                loading: true,
            };
        case GET_TRANSLATIONS_RESPONSE:
            return {
                ...state,
                loading: false,
                translations: action.payload,
            };
        default:
            return state;
    }
};
